module.exports = __webpack_public_path__ + "static/media/present_christmas_important.5271f36b.svg";